/* global $ */
class ReadMoreLess {
  constructor(options = {}) {
    this.config = {
      readmore: document.querySelectorAll('[href=js-readmore]'),
      readless: document.querySelectorAll('[href=js-readless]'),
      dots: false,
      ...options
    };
  }

  init() {
    const { readmore, readless } = this.config;

    readmore.forEach(element => {
      element.classList.add('c-readmore__more');
      element.addEventListener('click', e => {
        e.preventDefault();
        element.parentNode.classList.remove('has-siblings-hidden');
      });

      /*eslint-disable */
      $(element)
        .parentsUntil('.text-container')
        .contents()
        .filter(function(){
          return this.nodeType === 3;
        })
        .wrap('<span />');
      /* eslint-enable */

      element.parentNode.classList.add('c-readmore', 'js-readmore-parent', 'has-siblings-hidden');
    });

    readless.forEach(element => {
      element.classList.add('c-readmore__less');
      element.addEventListener('click', e => {
        e.preventDefault();
        const moreLink = element.closest('div').getElementsByClassName('js-readmore-parent')[0];
        moreLink.classList.add('has-siblings-hidden');
      });
    });
  }
}

export default ReadMoreLess;
